import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
import "../App.css";
import "../styles/Home.css";

import AboutTransition from "../pages/AboutTransition";

export default function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => setScrollY(window.scrollY);

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const heroHidden = scrollY > 450;

  return (
    <section className="home-container" id="home">
      <AboutTransition />

      <div className={`Home-image ${heroHidden ? "hero-hidden" : ""}`}>
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          aria-label="Main background video"
        >
          <source src="/assets/MainPage/hero-video.mp4" type="video/mp4" />
          Your browser doesn’t support HTML5 video.
        </video>

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <p className="hero-eyebrow">Global Safety Consulting & Innovation</p>

          <h1 className="hero-title">
            Safety solutions built for whats next
          </h1>

          {/* <p className="hero-subtitle">
            GalaxyEDGE Safety Inc. helps organizations build safer, smarter, and more
            resilient workplaces through expert consulting, digital transformation,
            AI-driven tools, and future-ready safety strategies.
          </p> */}

          <div className="cta-buttons">
            <Link to="learn_more" smooth duration={900}>
              <button className="cta-button learn-more">Explore Services</button>
            </Link>

            <NavLink to="/contact" end>
              <button className="cta-button contact-us">Book a Consultation</button>
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
}